//TODO: If possible, try not using kendo button. But just stick on pure css
import './index.css'
import React, { useState, useEffect, useRef } from 'react'

import Badge from '@mui/material/Badge'
import IconButton from '@mui/material/IconButton'
import NotificationsNoneSharpIcon from '@mui/icons-material/NotificationsNoneSharp'

import { Button } from '@mui/material'
import moment from 'moment'

import api from 'api'
import { useOnClickOutside } from 'hooks'
import { useSelector } from 'react-redux'
//TODO: temporary tooltip
import ToolTip from './ToolTip'
import closeButton from 'assets/close-btn.png'
import { Typography } from '@mui/material'
import I18n from 'i18next';

// sample response
// {
//   id: 27,
//   user_id: 32,
//   short_message: 'message2',
//   long_message: 'long message2',
//   created_on: '2022-05-06T11:42:50Z',
//   created_by: 'vivek',
//   expires_on: '2022-05-06T11:42:50Z',
//   opened_on: '2022-05-06T11:42:50Z',
//   status: 'A',
// },
const initialNotifications = []

const notificationsLabel = count => {
  if (count === 0) {
    return 'no notifications'
  }
  if (count > 99) {
    return 'more than 99 notifications'
  }
  return `${count} notifications`
}

const notificationsCount = count => {
  if (count === 0) {
    return null
  }
  if (count <= 9) {
    return `${count}`
  }
  return '9+'
}

const Notification = props => {
  const [open, setOpen] = useState(false)
  const [notifications, setNotifications] = useState(initialNotifications)
  const ref = useRef()
  useOnClickOutside(ref, () => setOpen(false))
  const user = useSelector(state => state.userReducer.user)

  const getAlerts = async () => {
    try {
      const res = await api.getUserAlerts()
      setNotifications(res.details)
    } catch (error) {
      console.error(error)
    }
  }

  const deleteHandler = async (e, deleteItem) => {
    try {
      e.preventDefault()
      await api.markAsReadAlerts([deleteItem.id])
      getAlerts()
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    if (!user) return
    getAlerts()
  }, [user])

  return (
    <div className="notification-wrapper" ref={ref}>
      <IconButton
        sx={{ marginRight: '20px' }}
        aria-label={notificationsLabel(notifications.length)}
        onClick={() => setOpen(!open)}
      >
        <Badge color="error" badgeContent={notificationsCount(notifications.length)} sx={{ '& .MuiBadge-badge': { fontSize: 12 } }}>
          <NotificationsNoneSharpIcon color="primary" sx={{ fontSize: 25, width: '1em', height: '1em' }} />
        </Badge>
      </IconButton>
      {open && (
        <div className="notification-box color-primary">
          <span className="close-notification-box" onClick={() => setOpen(false)}>
            <img src={closeButton} alt="close-button" height={30} onClick={() => setOpen(false)} />
          </span>
          <h4>{I18n.t('header.notifications')}</h4>
          <ul>
            {notifications.map(notification => {
              return (
                <li key={notification.id}>
                  <div className="row1">
                    <span className="time">{moment(notification.created_on).format('MM/DD/YYYY hh:mm A')}</span>
                  </div>
                  <div className="row2">
                    <ToolTip
                      toolTipContent={() => notification.short_message}
                      customStyle={{ color: 'white', padding: '10px', zIndex: '9999', fontSize: '12px', backgroundColor: '#0A78CD' }}
                    >
                      <Typography variant="body2" color="#212529">
                        {notification.short_message.length > 35
                          ? notification.short_message.slice(0, 35) + '...'
                          : notification.short_message}
                      </Typography>
                    </ToolTip>
                    <Button className='notification-button' onClick={e => deleteHandler(e, notification)}>Delete</Button>
                  </div>
                </li>
              )
            })}
          </ul>
        </div>
      )}
    </div>
  )
}

export default Notification

/*
A Arrive
R Read
D Delete
*/
